import React, { useState, useEffect } from 'react';
import MainLayout from './mainLayout';
import PointerItem from '../components/pointerItem';
import { useData } from '../hooks/useContext';
import Pagination from '../components/pagination';
import { paginate } from '../utils/paginate';
import Loader from '../components/loader';
import { ILocation, IUseData } from '../interfaces';
import PageCard from '../components/pageCard';
import { CONFIG } from '../config';
import Search2 from '../components/search2';
import locationsService from '../services/locations.service';

const LocationsList = () => {
  const { setPage, locations, theme } = useData() as IUseData;
  const [paginationPage, setPaginationPage] = useState<number>(1);
  const [filteredLocations, setFilteredLocations] = useState<ILocation[]>([]);

  const pageSize: number = 16;

  useEffect(() => {
    setPage('locations');
    document.title = CONFIG.PAGES_CARDS.LOCATIONS_PAGE.HEADER;
  }, []);

  useEffect(() => {
    setFilteredLocations(locations);
  }, [locations]);

  const handleSearchResult = (data: any) => {
    console.log('LocationList.handleSearchResult()', data);

    if (data == null) {
      setFilteredLocations(locations);
    } else {
      let newLocs: ILocation[] = [];
      locations.forEach((loc: ILocation) => {
        if (data.includes(loc._id)) {
          newLocs.push(loc);
        }
      });
      setFilteredLocations(newLocs);
    }
  };

  return (
    <MainLayout>
      {/* <div className="m-auto w-full 2xl:w-4/5 h-100 md:px-12 flex flex-col px-2"> */}
      <PageCard />
      {CONFIG.SHOW_SEARCH2 ? <Search2 onResult={handleSearchResult} searchFunction={locationsService.search2} /> : null}
      <main className={'grow flex flex-col rounded-[40px] p-[40px] my-5' + theme.active}>
        {filteredLocations ? (
          <>
            <h2 className={'text-2xl font-medium mb-2 border-b-2' + theme.redBorder} autoFocus={true}>
              {'Адреса (' + filteredLocations.length + ')'}
            </h2>
            <ul>
              {paginate<ILocation>(filteredLocations, paginationPage, pageSize).map((item: ILocation) => (
                <PointerItem
                  key={item._id}
                  name={item.adress}
                  link={'locations/' + item._id}
                  num={filteredLocations.indexOf(item) + 1}
                />
              ))}
            </ul>
            <Pagination
              productCount={filteredLocations.length}
              pageSize={pageSize}
              currentPage={paginationPage}
              onPageChange={(page: number) => setPaginationPage(page)}
            />
          </>
        ) : (
          <Loader title={'Загрузка списка адресов...'} />
        )}
      </main>
      {/* </div> */}
    </MainLayout>
  );
};

export default LocationsList;
